import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChatreact = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "replace",
	stroke: "replace",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M26.18 19.6473C27.1931 18.1455 27.788 16.3378 27.788 14.391C27.788 9.20879 23.5776 5 18.3728 5H13.4244C8.21962 5 4 9.20879 4 14.4002C4 19.5917 8.21962 23.8005 13.4244 23.8005H18.9491C20.9287 23.8005 22.8991 24.162 24.7487 24.8666L28.1411 26.1552L26.18 19.6473Z",
		strokeWidth: 1.5,
		strokeMiterlimit: 10,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgChatreact;
